import axios from "axios";
//import { AppointmentDto } from "../types/appointment";
import { handleApiError } from "../../common/api/apiErrorHandler";
import { AppointmentSurveyDto } from "../types/appointmentSurvey";

export default class ExternalSurveyApi {
  static async patchAppointmentSurvey(apptSurvey: AppointmentSurveyDto): Promise<AppointmentSurveyDto> {
    try {
      const response = await axios.patch(`/api/AppointmentSurveys`, apptSurvey);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async getAppointmentSurveyForAppointment(apptId: number): Promise<AppointmentSurveyDto> {
    try {
      const response = await axios.get(`/api/AppointmentSurveys?appointmentId=${apptId}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
}
